import {
  AcceptedLicensesDto,
  CompanyResponseDto,
  countryCode,
  CountryInfoDto,
  RegexDto
} from "../dto/company-response-dto";
import * as Sentry from "@sentry/angular";

export class Company {

  id: number = 0;
  key?: string;
  name?: string;
  acceptedLicenses: AcceptedLicense[] = [];
  phoneAuthorizedCountries: countryCode[] = [];
  countryInfo: CountryInfoDto[] = [];

  constructor(dto?: CompanyResponseDto) {
    if (dto) {
      this.id = dto.id;
      this.key = dto.key;
      this.name = dto.name;
      this.acceptedLicenses = dto.acceptedLicenses.map(d => AcceptedLicense.fromDto(d, dto.countryInfo));
      this.phoneAuthorizedCountries = dto.phoneAuthorizedCountries;
      this.countryInfo = dto.countryInfo;
    }
  }
}

export class AcceptedLicense {
  countryCode: countryCode;
  countryFlagUrl: string = '';
  countryName: string = '';
  regexList: RegexDto[] = [];

  constructor(countryCode: countryCode, regexList: RegexDto[]) {
    this.countryCode = countryCode;
    this.regexList = regexList;
  }
  public static fromDto(dto: AcceptedLicensesDto, countries: CountryInfoDto[]) {
    const country = countries.find((c) => c.countryCode === dto.countryCode);
    const license = new AcceptedLicense(dto.countryCode, dto.regexList);
    if (country){
      license.countryFlagUrl = country.countryFlagUrl;
      license.countryName = country.countryName;
    } else {
      Sentry.captureException(new Error(`Configuration error: no matching country found`), {extra: {countryCode: dto.countryCode}});
    }
    return license;
  }
}
